import { redirect } from "react-router"
import type { LoaderFunctionArgs } from "react-router"
import { useUserInfoStore, useEthereumStore } from "../../state"
import { useSubscriptionStore } from "../../state/stores/subscriptionStore"
import { isReviewerSession } from "../../utils/reviewer"
import { runWalletProtectedGate } from "../../utils/reviewer/walletGateFlow.ts"

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const result = await runWalletProtectedGate({
    isReviewer: isReviewerSession,
    getUserInfo: () => useUserInfoStore.getState().getOrFetch(),
    getWalletState: () => useEthereumStore.getState().getOrFetch(),
    disconnectWallet: () => useEthereumStore.getState().disconnectWallet(),
    loadSubscription: () => useSubscriptionStore.getState().loadSubscription(),
    pathname: new URL(request.url).pathname,
  })

  if (result.type === "redirect") return redirect(result.to)
  if (result.type === "mismatch") throw new Response("WALLET_MISMATCH", { status: 403 })
  return null
}
